import { Trash2, CircleHelp } from "lucide-react";
import { Button } from "@/components/ui/button";

const DeleteModal = ({ show, label, onClose, onConfirm, mode = "delete" }: any) => {
    if (!show) return null;

    const isDelete = mode === "delete";
    const title = isDelete ? "Confirm Delete" : "Confirmation";
    const actionButtonText = isDelete ? "Yes, Delete" : "Yes, Confirm";

    return (
        <div className="modal fade show d-block bg-foreground/50 dark:bg-background/80" tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby="deleteModalTitle">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div data-evo-island className="flex flex-col gap-4 p-6 text-foreground">
                        <div className="flex items-start gap-3">
                            <span className={isDelete
                                ? "flex size-10 shrink-0 items-center justify-center rounded-full bg-destructive/10 text-destructive"
                                : "flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"} aria-hidden="true">
                                {isDelete ? <Trash2 className="size-5" /> : <CircleHelp className="size-5" />}
                            </span>
                            <div className="min-w-0 flex-1">
                                <h2 id="deleteModalTitle" className="text-lg font-semibold leading-7">{title}</h2>
                                <p className="text-sm text-muted-foreground break-words">
                                    {isDelete ? (
                                        <span>Are you sure you want to delete <strong className="font-semibold text-foreground">{label}</strong>?</span>
                                    ) : (
                                        <strong className="font-semibold text-foreground">{label}</strong>
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap justify-end gap-2">
                            <Button type="button" variant="outline" onClick={onClose}>
                                Cancel
                            </Button>
                            <Button
                                type="button"
                                variant={isDelete ? "destructive" : "default"}
                                onClick={() => {
                                    onConfirm();
                                    onClose();
                                }}
                            >
                                {actionButtonText}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteModal;
